import React, {ReactElement} from 'react';
import IconWrapper, {IconProps} from '../IconWrapper';

export function CollapseIcon(props: IconProps): ReactElement {
  return (
    <IconWrapper {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM9.33333 13.3334H10.6667H13.3333H14.6667C15.403 13.3334 16 12.7365 16 12.0001C16 11.2637 15.403 10.6667 14.6667 10.6667H13.3333H10.6667H9.33333C8.59695 10.6667 8 11.2637 8 12.0001C8 12.7365 8.59695 13.3334 9.33333 13.3334Z"
      />
    </IconWrapper>
  );
}
